import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';

import { getInterests } from './restApi';

import PageController from '../../Shared/UI/PageController/components/PageController';

const InterestsModalPageController = () => {
  const state = useProfileState();
  const { onResponse, onError } = useProfileActions();

  return (
    <PageController
      pageNumber={state.interestsModal?.pageNumber}
      numberOfPages={state.interestsModal?.numberOfPages}
      goToFirstPage={() => {
        getInterests({
          onResponse,
          onError,
          pageNumber: 1,
          debouncedInterestNameForFuzzyFilter: state?.interestsModal?.newUnrecognizedInterestForm?.debouncedInterestNameForFuzzyFilter,
          interestName: state?.interestsModal?.newUnrecognizedInterestForm?.interestName,
        });
      }}
      goToPreviousPage={() => {
        getInterests({
          onResponse,
          onError,
          pageNumber: (state.interestsModal?.pageNumber - 1),
          debouncedInterestNameForFuzzyFilter: state?.interestsModal?.newUnrecognizedInterestForm?.debouncedInterestNameForFuzzyFilter,
          interestName: state?.interestsModal?.newUnrecognizedInterestForm?.interestName,
        });
      }}
      goToNextPage={() => {
        getInterests({
          onResponse,
          onError,
          pageNumber: (state.interestsModal?.pageNumber + 1),
          debouncedInterestNameForFuzzyFilter: state?.interestsModal?.newUnrecognizedInterestForm?.debouncedInterestNameForFuzzyFilter,
          interestName: state?.interestsModal?.newUnrecognizedInterestForm?.interestName,
        });
      }}
      goToLastPage={() => {
        getInterests({
          onResponse,
          onError,
          pageNumber: state.interestsModal?.numberOfPages,
          debouncedInterestNameForFuzzyFilter: state?.interestsModal?.newUnrecognizedInterestForm?.debouncedInterestNameForFuzzyFilter,
          interestName: state?.interestsModal?.newUnrecognizedInterestForm?.interestName,
        });
      }}
    />
  );
};

export default InterestsModalPageController;
